import React, { useEffect, useState } from 'react';
import './Management.css';
import { FaTrash, FaEye } from 'react-icons/fa'; // Trash and View icon
import axios from 'axios';
// import './Management3.css'



const Standardorder = () => {
  const [activeTab, setActiveTab] = useState('Order Life-Cycle');
  const [data, setData] = useState([]);
  const [orders, setOrders] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);

  const [vendorId, setVendorId] = useState(null);
  const [allOrders, setAllOrders] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(""); // format: YYYY-MM-DD
  const screenWidth = window.innerWidth;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const containerHeight = window.innerWidth < 768
    ? '300px'       // Mobile
    : window.innerWidth < 850
      ? '300px'     // Below 850px
      : window.innerWidth < 1400
        ? '410px'   // Between 850px and 1399px
        : window.innerWidth < 1600
          ? '480px' // Between 1400px and 1599px
          : '640px'; // Above 1600px


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const exportToCSV = () => {
    if (filteredData.length === 0) {
      alert("No data to export!");
      return;
    }

    // 1️⃣ Build CSV header
    const headers = [
      "S.No",
      "Order ID",
      "Date",
      "Category",
      "Type",
      "Name",
      "Payment",
      "Order Status",
      "Amount",
    ];

    // 2️⃣ Build CSV rows
    const rows = filteredData.map((item, index) => [
      index + 1,
      item.orderId,
      new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
      item.appType,
      item.orderType || item.orderService,
      item.userName,
      item.paymentMethod,
      item.status,
      Math.round(item.grandTotal),
    ]);

    // 3️⃣ Combine header + rows
    const csvContent =
      [headers, ...rows]
        .map((row) => row.map((v) => `"${v}"`).join(",")) // wrap each value in quotes
        .join("\n");

    // 4️⃣ Create a blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `orders_${new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  // Fetch orders from API
  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.error("Authorization token missing");
        return;
      }

      try {
        // 1️⃣ Normal orders
        const normalRes = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const normalOrders = normalRes.data || [];

        // 2️⃣ TABLE_DINE_IN completed orders
        const dineInRes = await axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/COMPLETED`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const dineInOrdersRaw = dineInRes.data || [];
        const dineInOrders = dineInOrdersRaw.map((order) => ({
          orderId: order.cartId,
          orderDateAndTime: order.cartDateAndTime || new Date().toISOString(),
          appType: "Food",
          orderService: order.orderType,
          userName: order.userName || "Dine-in User",
          paymentMethod: order.paymentMethod || "N/A",
          status: "COMPLETED",
          grandTotal: order.grandTotal || 0,
        }));

        const combinedOrders = [...normalOrders, ...dineInOrders];
        setAllOrders(combinedOrders);
        setFilteredData(combinedOrders); // initially show all
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
  }, [vendorId]);

  useEffect(() => {
    if (!vendorId) return;

    const fetchOrders = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        console.warn("Auth token missing. Skipping order fetch.");
        return;
      }

      try {
        // 1️⃣ Fetch normal orders
        const ordersRes = await axios.get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        // Filter normal orders based on status
        const processingOrders = ordersRes.data.filter(order =>
          ["CONFIRMED", "PROCESSING", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(order.status)
        );

        // 2️⃣ Fetch TABLE_DINE_IN orders for relevant statuses
        const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP", "COMPLETED"];
        const dineInPromises = dineInStatuses.map(status =>
          axios.get(
            `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
            { headers: { Authorization: `Bearer ${token}` } }
          )
        );

        const dineInResponses = await Promise.all(dineInPromises);
        let dineInOrders = dineInResponses.flatMap(res => res.data || []);

        // Filter TABLE_DINE_IN orders by cartItems status
        dineInOrders = dineInOrders.filter(order =>
          Array.isArray(order.cartItems) &&
          order.cartItems.some(item =>
            ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
          )
        );

        // 3️⃣ Combine normal and TABLE_DINE_IN orders and remove duplicates
        const combinedOrders = [...processingOrders, ...dineInOrders];
        const uniqueOrders = combinedOrders.filter(
          (order, index, self) =>
            index === self.findIndex(
              o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
            )
        );

        setOrders(uniqueOrders);
        // console.log("✅ Final Unique Orders:", uniqueOrders);
      } catch (error) {
        console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
      }
    };

    fetchOrders();
    const intervalId = setInterval(fetchOrders, 1000); // Fetch every 1 second
    return () => clearInterval(intervalId);
  }, [vendorId]);







  // Filter orders whenever selectedDate changes
  useEffect(() => {
    if (!selectedDate) {
      setFilteredData(allOrders); // show all if no date selected
      return;
    }

    const filtered = allOrders.filter((order) => {
      const orderDate = new Date(order.orderDateAndTime)
        .toISOString()
        .split("T")[0]; // format YYYY-MM-DD
      return orderDate === selectedDate;
    });

    setFilteredData(filtered);
  }, [selectedDate, allOrders]);




  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    if (storedVendorId) {
      setVendorId(storedVendorId);
    }
  }, []);

  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    if (!vendorId) return;

    const fetchData = () => {
      const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
      if (!token) {
        console.warn("No auth token found. Skipping fetch.");
        return;
      }

      axios
        .get(
          `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // ✅ Include token in header
            },
          }
        )
        .then((res) => setData(res.data))
        .catch((err) =>
          console.error("Error fetching orders with token:", err.response?.data || err.message)
        );
    };

    fetchData(); // initial fetch

    const interval = setInterval(fetchData, 1000); // fetch every 1 second

    return () => clearInterval(interval); // cleanup
  }, [vendorId]);







  const [showDetails, setShowDetails] = useState(false);

  const orderStages = ["Order Placed", "Order Preparing", "Order is Ready", "Order on the way", "Order Delivered"];

  const styles = {
    card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)", },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    orderId: { margin: 0, fontWeight: "bold" },
    date: { fontSize: '18px', color: '#000', fontWeight: "bold" },
    pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold", },
    tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
    statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
    arrow: { margin: '0 5px' },
    dropdownBtn: {
      background: 'none',
      border: 'none',
      fontSize: '20px',
      cursor: 'pointer',
      ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '100px' } : {}), // 👈 conditional style
    },
    itemList: { marginTop: '10px', fontWeight: "bold" },
    itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
  };

  // {=======================overview===============================}
  const tabContent = {
    "Order Life-Cycle": <div>
      {orders.map((order) => {
        // For TABLE_DINE_IN orders, use cartItems; otherwise use orderItems
        const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
        const orderId = order.orderId || order.cartId; // fallback for TABLE_DINE_IN
        const selected = selectedItems[orderId] || [];

        return (
          <div key={orderId} style={styles.card}>
            <div style={styles.header}>
              <h3 style={styles.orderId}>Order ID: {orderId}</h3>
              <button style={styles.pickupBtn} className='pickup-btn-data'>
                {order.service || order.orderType || 'Service'}
              </button>
              <button
                style={styles.dropdownBtn}
                onClick={() =>
                  setShowDetails((prev) => ({
                    ...prev,
                    [orderId]: !prev[orderId],
                  }))
                }
              >
                {showDetails[orderId] ? '▲' : '▼'}
              </button>
            </div>

            {showDetails[orderId] && (
              <>
                <p style={styles.date}>
                  {order.orderDateAndTime ? (() => {
                    const dateObj = new Date(order.orderDateAndTime);
                    const date = dateObj.toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                    });
                    const time = dateObj.toLocaleTimeString('en-IN', {
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true,
                    });
                    return (
                      <>
                        <span style={{ color: 'black' }}>Date: </span>
                        <span style={{ color: 'white' }}>{date}</span>
                        <br />
                        <span style={{ color: 'black' }}>Time: </span>
                        <span style={{ color: 'white' }}>{time}</span>
                      </>
                    );
                  })() : 'N/A'}
                </p>

                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    marginTop: '1rem',
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: '#b15cd6', textAlign: 'center' }}>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>S.No</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Item Name</th>
                      <th style={{ padding: '8px', border: '1px solid #ddd' }}>Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems.map((item, index) =>
                      // Keep your existing condition
                      item.status === "Okay" || item.orderType === "TABLE_DINE_IN" ? (
                        <tr
                          key={index}
                          style={{ borderBottom: '1px solid #eee', fontWeight: 'bold', backgroundColor: '#d4edda' }}
                        >
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{index + 1}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.dishName}</td>
                          <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.quantity || 1}</td>
                        </tr>
                      ) : null
                    )}
                  </tbody>
                </table>
              </>
            )}

            <div
              style={{
                ...styles.tracker,
                display: 'flex',
                justifyContent: 'center',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '5px' : '0px',
                alignItems: 'center',
              }}
            >
              {orderStages.map((stage, index) => {
                const stageOrder = orderStages;

                const statusToStage = {
                  PROCESSING: "Order Placed",
                  BEING_PREPARED: "Order Preparing",
                  ORDER_IS_READY: "Order is Ready",
                  WAITING_FOR_PICKUP: "Order on the way",
                  COMPLETED: "Order Delivered",
                };

                let isActive = false;

                if (order.orderType === "TABLE_DINE_IN" && Array.isArray(order.cartItems)) {
                  const relevantStatuses = [
                    "PROCESSING",
                    "BEING_PREPARED",
                    "ORDER_IS_READY",
                    "WAITING_FOR_PICKUP",
                  ];

                  let highestStageIndex = 0; // default = Order Placed

                  if (order.cartItems.every(item => item.orderStatus === "PROCESSING")) {
                    // ✅ Case 1: All items are PROCESSING → stay at "Order Placed"
                    highestStageIndex = 0;
                  } else {
                    // ✅ Case 2: At least one item is beyond PROCESSING → compute actual progress
                    const itemStageIndexes = order.cartItems
                      .filter(item => relevantStatuses.includes(item.orderStatus))
                      .map(item => stageOrder.indexOf(statusToStage[item.orderStatus] || "Order Placed"))
                      .filter(i => i !== -1);

                    highestStageIndex = itemStageIndexes.length > 0 ? Math.max(...itemStageIndexes) : 0;
                  }

                  isActive = index <= highestStageIndex;
                } else {
                  const currentStageIndex =
                    stageOrder.indexOf(statusToStage[order.status] || "Order Placed");
                  isActive = index <= currentStageIndex;
                }

                // ✅ Debug log
                if (isActive) {
                  // console.log(`✅ Highlighted Stage for Order ${order.orderId || order.cartId}:`, stage);
                } else {
                  // console.log(`❌ Not Highlighted Stage for Order ${order.orderId || order.cartId}:`, stage);
                }

                return (
                  <React.Fragment key={index}>
                    <div
                      style={{
                        ...styles.statusBox,
                        backgroundColor: isActive ? "green" : "#f0f0f0",
                        color: isActive ? "white" : "black",
                        borderRadius: "6px",
                        padding: "8px 12px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        transition: "0.3s",
                      }}
                    >
                      {stage}
                    </div>
                    {index !== orderStages.length - 1 && <span style={styles.arrow}></span>}
                  </React.Fragment>
                );
              })}



            </div>
          </div>
        );
      })}

    </div>
    ,
    Reports:
      <div style={{ scrollbarWidth: 'none', overflow: 'auto' }}>

        <div className="order-table-container">
          <style>
            {`
          .order-table-container {
            padding: 0px;
            font-family: Arial, sans-serif;
          }

          .filters {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 10px;
            
            
          }

          .filters select {
            padding: 8px 10px;
            border-radius: 5px;
            border: 1px solid #ccc;
            margin-right: 10px;
            min-width: 120px;
            background-color: #b15cd6;
            color: #fff;
            font-weight:bold;
          }

          .filters button {
            padding: 10px 20px;
            background-color: #b15cd6;
            color: #fff;
            border: none;
            border-radius: 5px;
            font-weight: bold;
            cursor: pointer;
            white-space: nowrap;
          }

          .table-wrapper {
            overflow-x: auto;
            margin-top: 0px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            min-width: 800px;
          }

          thead tr {
            background-color: #b15cd6;
          }

          th, td {
            padding: 10px;
            border: 1px solid #ddd;
            text-align: center;
            font-size: 14px;
          }

          tbody tr:nth-child(even) {
            background-color: #f9f9f9;
          }

          tbody tr:nth-child(odd) {
            background-color: #ffffff;
          }

          @media (max-width: 768px) {
            .filters {
              flex-direction: column;
              align-items: stretch;
            }

            .filters select {
              width: 100%;
              margin-right: 0;
            }

            .filters button {
              width: 100%;
              margin-top: 10px;
            }

            table {
              font-size: 12px;
            }
          }
        `}
          </style>

          {/* Filter Row */}
          <div className="filters">
            <div>
              <button>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  style={{ background: "rgb(177 92 214)", color: "#fff", border: "none" }}
                /></button>
            </div>
            <button onClick={exportToCSV}>Export</button>
          </div>

          {/* Table */}
          <div style={{ marginTop: "-15px" }} className="table-wrapper" >
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Order ID</th>
                  <th>Date</th>
                  <th>Category</th>
                  <th>Type</th>
                  <th>Name</th>
                  <th>Payment</th>
                  <th>Order Status</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center" }}>
                      No orders for selected date
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.orderId}</td>
                      <td>{new Date(item.orderDateAndTime).toLocaleDateString("en-GB")}</td>
                      <td>Food</td>
                      <td>{item.orderType || item.orderService}</td>
                      <td>{item.userName || "-"}</td>
                      <td>{item.paymentMethod}</td>
                      <td>{item.status}</td>
                      <td>₹{Math.round(item.grandTotal)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

          </div>
        </div>
      </div>


  };

  return (

    <div>

      <style>{`
        .main-container {
          padding: 20px;
          display: flex;
          flex-direction: column;
         
        }
@media screen and (min-width: 768px) {
         .tabs-wrapperyyy {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:-46px;
}
      }


/* Mobile view ke liye (max-width 768px ya 600px aapke design ke hisaab se) */
@media screen and (max-width: 768px) {
  .tabs-wrapper {
    margin-left: 0;
    
  }
       .tabs-wrapperyyy {
      display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          margin-left:0px;
          margin-top:-70px;
}
            .tab-content {
          width: 100%;
          max-width:944px;
          
        }
}


        .tab-buttons {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 10px;
          margin-top:42px;
         
        }

        .tab-button {
          border: none;
          border-radius: 10px;
          width: 150px;
          height: 40px;
          background-color: #d9d9d9;
          color: #000;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .tab-button.active {
          background-color: #b15cd6;
        }

      

        .sidebar {
          margin-top: 30px;
          max-height: 600px;
          overflow-y: auto;
        }

        .card {
          width: 100%;
          max-width: 300px;
          height: 120px;
          background: #ccc;
          border-radius: 8px;
          box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
          margin: 10px auto;
          position: relative;
          padding: 10px;
        }

        .card h5, .card p {
          color: white;
          margin: -18 !imortanant;
        }

        

        
        @media (min-width: 768px) {
          .main-container {
            flex-direction: row;
            justify-content: space-between;
          }
  .tab-content {
          margin-top: 20px;
          width: 100%;
          max-width:944px;
          
        }

         .left-column {
    padding-right: 0;
    display: flex;
    flex-direction: column;         /* stack children vertically */
           
    justify-content: center;        /* center vertically */
    text-align: center;
    margin: 0 auto;
  }

          .right-column {
            width: 30%;
            position: sticky;
            top: -30px;
            max-height: 700px;
            overflow-y: auto;
          }

          .card {
            margin-left: 0;
          }
            .tabs-wrapperyyy{
            margin-left:none

            }

        }

        /* Hide native scrollbars */
        .sidebar::-webkit-scrollbar,
        .left-column::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
      `}</style>

      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-12">


            {/* Left Section */}
            <div className="left-column" style={{}}>
              <div className="tabs-wrapperyyy ">

                <div className="tab-buttons" style={{}}>
                  {Object.keys(tabContent).map((label) => (
                    <button
                      key={label}
                      className={`tab-button ${activeTab === label ? "active" : ""}`}
                      onClick={() => setActiveTab(label)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
                <div className="tab-content" style={{
                  overflow: 'auto',
                  height: window.innerHeight<400 ? "50vh" :window.innerHeight<500 ? "55vh" : window.innerHeight<600 ? "60vh" : containerHeight,
                  scrollbarWidth: "normal",
                  msOverflowStyle: "none", maxWidth: '944px',
                }}>{tabContent[activeTab]}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default Standardorder;
